import React, { useState } from 'react'
// import Search from '../assets/icons/search.svg'
import { HiOutlinePuzzlePiece } from "react-icons/hi2";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { HiOutlinePencilAlt } from "react-icons/hi";
import ApplicationProcesses from '../components/tabs/ApplicationProcesses'
import VerificationProcess from '../components/tabs/VerificationProcess';
import PostExam from '../components/tabs/PostExam';
import GalleryModal from '../components/modals/GalleryModal';
import Gallery from '../components/modals/Gallery';
import DashboardLayout from './DashboardLayout';




const Processes = () => {
  const [active, setActive] = useState('Application')

  const [modal, setModal] = useState(false);
  const [data, setData] = useState();

  const handleTab = (item) => {
    setActive(item)
  }


  return (
    <DashboardLayout processes='Processes' animated={true}>
    <div className='flex flex-col items-center justify-center w-full px-5 pb-7 mt-4 md:px-6 lg:relative lg:px-7 xl:px-10 xl:pb-10'>
        {/*SEARCH*/}
        {/* <div className='flex flex-col items-start mt-4 w-full bg-[#F9FAFB] p-2 rounded-md md:mt-0 md:px-4 lg:px-6 lg:p-3 lg:rounded-lg'>
            <p className='text-[11px] text-[#101828] font-medium xl:text-sm'>
               Search Processes             
            </p>
            <div className='relative h-9  mt-1 w-full xl:h-11'>
                <input className='border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[10px] text-[#101828] font-normal pl-9 outline-[#25A249] 
                                  xl:text-sm xl:pl-12 xl:rounded-lg' 
                 placeholder='Search processes'
                />
                <img className='absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5' src={Search} alt='search_icon' />
            </div>
        </div> */}


        {/*TABS*/}
        <div className='flex items-center justify-start w-full flex-wrap'>
            {/*APPLICATION TAB*/}
            <div onClick={()=>handleTab('Application')}
             className={`flex flex-col items-start mt-7 mr-10 cursor-pointer ${active === 'Application' ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                <div className='flex items-end'>
                    <HiOutlinePuzzlePiece className={`text-xl`} />
                    <p className={`text-[11px] font-medium pl-1.5 md:text-xs xl:text-sm`}>
                        Application process            
                    </p>
                </div>
                <div className={`w-[130px] border-[1px] rounded-lg mt-1.5 md:w-[141px] xl:w-[161px] ${active === 'Application' ? 'border-[#25A249]' : 'border-[#ffffff]'} `}></div>
            </div>


            {/*VERIFICATION TAB*/}
            <div onClick={()=>handleTab('Verification')}
            className={`flex flex-col items-start mt-7 cursor-pointer md:mr-10 ${active === 'Verification' ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                <div className='flex items-end'>
                    <AiOutlineCheckCircle className={`text-xl`} />
                    <p className={`text-[11px] font-medium pl-1.5 md:text-xs xl:text-sm`}>
                        Verification process             
                    </p>
                </div>
                <div className={`w-[130px] border-[1px] rounded-lg mt-1.5 md:w-[142px] xl:w-[163px] ${active === 'Verification' ? 'border-[#25A249]' : 'border-[#ffffff]' }`}></div>
            </div>


            {/*POSTEXAM TAB*/}
            <div onClick={()=>handleTab('PostExam')}
            className={`flex flex-col items-start mt-7 cursor-pointer ${active === 'PostExam' ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                <div className='flex items-end w-full'>
                    <HiOutlinePencilAlt className={`text-xl`} />
                    <p className={`text-[11px] font-medium pl-1.5 md:text-xs xl:text-sm`}>
                        Post exam and admission            
                    </p>
                </div>
                <div className={`w-[160px] border-[1px] rounded-lg mt-1.5 md:w-[173px] xl:w-[200px] ${active === 'PostExam' ? 'border-[#25A249]' : 'border-[#ffffff]' }`}></div>
            </div>

        </div>


        {/*TAB CONTENTS*/}
        {
          active === 'Application' ? <ApplicationProcesses setData={setData} setModal={setModal} />
         :active === 'Verification' ? <VerificationProcess setData={setData} setModal={setModal} />
         :active === 'PostExam' && <PostExam setData={setData} setModal={setModal} />
        }


        {/*MODALS*/}
        {modal &&
            <GalleryModal onClick={()=>setModal(false)}>
                <Gallery data={data} setModal={setModal} />
            </GalleryModal>
        }

    </div>
    </DashboardLayout>
  )
}

export default Processes
